/* eslint-disable func-names */
import EDC from '../../../shared/globals';

EDC.Animations.Bird = function (scene) {
  this.scene = scene;
  this.bird = null;
};

EDC.Animations.Bird.prototype.create = function () {
  this.bird = this.scene.add.sprite(-200, 150, 'bird');
  this.bird.setScale(-0.8, 0.8);
};

EDC.Animations.Bird.prototype.start = function () {
  this.startUp();
  this.randomDelay();
};

EDC.Animations.Bird.prototype.startUp = function () {
  this.bird.setFrame(1);
  this.scene.tweens.add({
    targets: this.bird,
    y: this.bird.y + 15,
    duration: 250,
    ease: 'Sine.easeInOut',
    onComplete: this.startDown.bind(this),
  });
};

EDC.Animations.Bird.prototype.startDown = function () {
  this.bird.setFrame(0);
  this.scene.tweens.add({
    targets: this.bird,
    y: this.bird.y - 15,
    duration: 250,
    ease: 'Sine.easeInOut',
    onComplete: this.startUp.bind(this),
  });
};

EDC.Animations.Bird.prototype.startHorizontal = function () {
  this.bird.x = -200;
  this.scene.tweens.add({
    targets: this.bird,
    x: this.scene.game.config.width + 200,
    duration: 5000,
    ease: 'Linear',
    onComplete: this.randomDelay.bind(this),
  });
};

EDC.Animations.Bird.prototype.randomDelay = function () {
  const time = 1000 * 5 + Math.round(Math.random() * (1000 * 25));
  this.scene.time.addEvent({
    delay: time,
    callback: this.startHorizontal,
    callbackScope: this,
  });
};

export default EDC.Animations.Bird;
